export default {
  hint: "Счётчики записей живого каталога НБР.",
  relation: "Связи",
  total: "Всего записей",
  updated: "Обновлено {{date}}",
  countsTitle: "Записи каталога НБР",
  byYear: "Издания по годам",
  topPublishers: "Издательства",
  topSubjects: "Тематики",
  topPrizes: "Премии",
  empty: "Статистика пока не собрана.",
}
